import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import { getItem, removeItem, setItem } from "../safeStorage";

/*
 * The viewer's switch for hiding pupils' names on their own screen.
 *
 * Persisted because it outlives the component that renders it, the same way the
 * sidebar width does: someone who hid names to share a screen must not have
 * them come back on the next navigation.
 *
 * A store rather than component state because the axios layer reads it too, on
 * every request, and it has no React to read from.
 *
 * The switch only ever hides. The server treats it as "mask more" and has no
 * inverse, so a viewer without clearance cannot reach a name by sending it --
 * which is why it is safe to carry on every request.
 */
export const MASK_NAMES_PARAM = "mask_names";

export const useMaskNamesStore = create(
  persist(
    (set) => ({
      maskNames: false,
      setMaskNames: (maskNames) => set({ maskNames }),
    }),
    {
      name: "maskStudentNames",
      // Through safeStorage, never `localStorage` directly: this module is on
      // the landing page's import path via api.js, and iOS Safari throws on
      // any touch of storage when the visitor blocks cookies -- at module
      // scope that aborts the bundle and the page comes up blank.
      storage: createJSONStorage(() => ({ getItem, setItem, removeItem })),
    }
  )
);

export const maskNamesRequested = () => useMaskNamesStore.getState().maskNames;
